module.exports = __webpack_public_path__ + "static/img/8.f53ceb4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/8/1/zh/8.png
// module id = KJz7
// module chunks = 0